var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPapers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 150,
    viewBox: "0 0 175 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3810_10118)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80.1602 108.549L158.503 120.402H80.1602V108.549Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80.1602 105.861L88.5839 49.873L167.718 61.8462L158.907 120.403H158.503L80.1602 108.549V105.861Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M88.584 49.8728L96.0877 0H96.4923L174.835 11.8534V14.542L167.718 61.8459L88.584 49.8728Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M174.835 11.8534L96.4922 0H174.835V11.8534Z",
    fill: "#808080"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M97.3713 0.951881L81.3994 107.101L157.748 118.653L173.72 12.5045L97.3713 0.951881Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.611 48.5246L100.107 51.874L155.211 60.212L155.715 56.8626L100.611 48.5246Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3516 56.8967L98.8477 60.2461L153.952 68.5841L154.456 65.2346L99.3516 56.8967Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.357 25.7736L130.854 29.123L159.241 33.4185L159.745 30.069L131.357 25.7736Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.604 34.5265L132.1 37.876L155.478 41.4135L155.982 38.064L132.604 34.5265Z",
    fill: "#F5D776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0899 65.2697L97.5859 68.6191L146.012 75.9466L146.516 72.5972L98.0899 65.2697Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8292 73.6428L96.3252 76.9922L138.071 83.3089L138.575 79.9595L96.8292 73.6428Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5694 82.0148L95.0654 85.3643L131.802 90.923L132.306 87.5736L95.5694 82.0148Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3106 90.3879L93.8066 93.7373L140.561 100.812L141.065 97.4625L94.3106 90.3879Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0518 98.7599L92.5479 102.109L110.915 104.889L111.419 101.539L93.0518 98.7599Z",
    fill: "#F5D776"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.125 38.4248L115.067 40.2316H103.125V38.4248Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.125 28.0317L103.418 26.0859L126.501 29.5784L124.898 40.2323H115.067L103.125 38.4255V28.0317Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.418 26.0856L104.847 16.5869H110.361L126.904 19.0898V26.9047L126.501 29.5781L103.418 26.0856Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M126.904 19.0898L110.361 16.5869H126.904V19.0898Z",
    fill: "#808080"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M114.78 39.246C120.819 39.246 125.714 34.3371 125.714 28.2817C125.714 22.2263 120.819 17.3174 114.78 17.3174C108.742 17.3174 103.847 22.2263 103.847 28.2817C103.847 34.3371 108.742 39.246 114.78 39.246Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.797 31.8934C109.797 31.8934 107.197 31.7149 107.163 36.5243C107.465 36.9173 107.841 37.2466 108.271 37.4929L110.459 32.7939L109.797 31.8934Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.157 33.1592C118.157 33.1592 120.701 33.7608 119.313 38.3636C118.909 38.6514 118.452 38.8559 117.969 38.9652L117.259 33.829L118.157 33.1592Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.068 24.2002C111.068 24.2002 109.305 27.5916 108.687 27.1544C108.687 27.1544 114.298 33.7185 120.836 28.9914C120.328 27.7137 119.668 26.5018 118.872 25.3815L111.068 24.2002Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.057 25.2212C120.456 22.5675 118.635 20.0916 115.989 19.6912C113.342 19.2908 110.873 21.1174 110.474 23.7712C110.075 26.4249 111.896 28.9008 114.543 29.3012C117.189 29.7016 119.658 27.875 120.057 25.2212Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.106 33.1512L109.747 31.8877L108.463 35.1226C108.463 35.1226 107.771 36.6047 108.239 37.3749C108.707 38.145 113.796 40.5015 118.038 38.9793C118.514 38.1368 118.701 37.1609 118.57 36.2016C118.36 34.5691 118.476 36.0733 118.476 36.0733L118.106 33.1512Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.219 33.1688L109.859 31.9053L108.577 35.1382C108.577 35.1382 107.885 36.6203 108.353 37.3904C108.821 38.1606 113.911 40.5171 118.153 38.9949C118.628 38.1523 118.815 37.1765 118.685 36.2172C118.475 34.5847 118.591 36.0888 118.591 36.0888L118.219 33.1688Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.156 33.159L109.796 31.8955L108.512 35.1305C108.512 35.1305 107.82 36.6126 108.288 37.3827C108.756 38.1528 113.846 40.5094 118.088 38.9871C118.564 38.1446 118.751 37.1687 118.62 36.2094C118.41 34.5769 118.526 36.0811 118.526 36.0811L118.156 33.159Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M112.777 29.51L116.121 30.016L115.666 33.0421C115.555 33.7792 114.869 34.2866 114.134 34.1755L113.45 34.072C112.715 33.9607 112.209 33.2732 112.32 32.5359L112.775 29.5098L112.777 29.51Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.793 29.3857L116.137 29.8917L115.682 32.9179C115.571 33.655 114.885 34.1624 114.15 34.0512L113.468 33.948C112.733 33.8367 112.227 33.1492 112.337 32.4119L112.793 29.3857Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M112.73 29.8591C113.747 30.4261 114.933 30.6088 116.072 30.3745L116.134 29.9634L112.79 29.458L112.73 29.8591Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.901 26.2632C120.3 23.6095 118.479 21.1336 115.832 20.7332C113.186 20.3327 110.717 22.1594 110.318 24.8131C109.918 27.4669 111.74 29.9428 114.386 30.3432C117.033 30.7436 119.502 28.9169 119.901 26.2632Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.791 23.0143L119.931 24.3961C119.931 24.3961 119.707 20.5856 116.217 20.2908C112.727 19.996 110.791 23.0143 110.791 23.0143Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.891 24.6884C110.961 24.2251 110.818 23.8194 110.572 23.7822C110.327 23.745 110.071 24.0905 110.001 24.5537C109.932 25.017 110.074 25.4227 110.32 25.4599C110.566 25.4971 110.821 25.1517 110.891 24.6884Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.253 26.1064C120.323 25.6431 120.18 25.2374 119.935 25.2002C119.689 25.163 119.433 25.5084 119.364 25.9717C119.294 26.435 119.437 26.8407 119.682 26.8779C119.928 26.9151 120.184 26.5696 120.253 26.1064Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M110.776 23.1393L119.916 24.5211C119.916 24.5211 119.692 20.7106 116.202 20.4158C112.712 20.121 110.776 23.1393 110.776 23.1393Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.5156 136.989L95.9529 124.276V136.989H17.5156Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.109 136.989L7.66113 78.3661L86.8903 65.5254L95.9526 121.756V124.277L17.5154 136.989H17.109Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.66095 78.3659L0 30.8302V28.309L78.437 15.5967H78.8434L86.8901 65.5252L7.66095 78.3659Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M78.437 15.5967L0 28.3091V15.5967H78.437Z",
    fill: "#808080"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M77.2558 16.2286L1.06152 28.7568L18.3823 134.691L94.5765 122.163L77.2558 16.2286Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.725 63.9774L18.7324 73.0195L19.279 76.3622L74.2715 67.3201L73.725 63.9774Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0912 72.3329L20.0986 81.375L20.6452 84.7177L75.6377 75.6755L75.0912 72.3329Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3555 37.2393L41.0254 41.8975L41.5719 45.2401L69.902 40.582L69.3555 37.2393Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2208 46.0066L44.8896 49.8428L45.4362 53.1854L68.7673 49.3492L68.2208 46.0066Z",
    fill: "#F5D776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7928 81.7851L21.4648 89.7314L22.0114 93.0741L70.3393 85.1278L69.7928 81.7851Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4924 91.2348L22.8311 98.085L23.3776 101.428L65.0389 94.5775L64.4924 91.2348Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8596 100.414L24.1973 106.442L24.7438 109.785L61.4062 103.757L60.8596 100.414Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2238 107.124L25.5635 114.796L26.11 118.139L72.7703 110.466L72.2238 107.124Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2609 120.138L26.9307 123.152L27.4772 126.495L45.8074 123.481L45.2609 120.138Z",
    fill: "#F5D776"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.5264 61.013L38.9616 58.9688V61.013H26.5264Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.7058 61.0135L14.9316 50.1609L38.5957 46.2705L38.9618 48.5113V58.9692L26.5267 61.0135H16.7058Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.9315 50.1607L14.4355 47.1265V39.3737L31.351 36.5928H37.0134L38.5955 46.2704L14.9315 50.1607Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.351 36.5928L14.4355 39.3737V36.5928H31.351Z",
    fill: "#808080"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M26.9086 60.3646C33.116 60.3646 38.1482 55.3183 38.1482 49.0934C38.1482 42.8685 33.116 37.8223 26.9086 37.8223C20.7011 37.8223 15.6689 42.8685 15.6689 49.0934C15.6689 55.3183 20.7011 60.3646 26.9086 60.3646Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8177 54.2354C22.8177 54.2354 20.2178 54.8872 21.6977 59.6002C22.1167 59.891 22.5893 60.0956 23.0877 60.2019L23.7496 54.9112L22.8177 54.2354Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3936 52.8247C31.3936 52.8247 34.0715 52.6061 34.1615 57.5518C33.8557 57.9571 33.4731 58.2978 33.0356 58.5545L30.7236 53.7533L31.3936 52.8247Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8285 50.2563C28.5799 50.2563 30.8104 48.0196 30.8104 45.2605C30.8104 42.5014 28.5799 40.2646 25.8285 40.2646C23.0771 40.2646 20.8467 42.5014 20.8467 45.2605C20.8467 48.0196 23.0771 50.2563 25.8285 50.2563Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3436 52.833L22.7679 54.2369L22.5299 57.8088C22.5299 57.8088 22.3299 59.4794 23.0198 60.0831C23.7098 60.6867 29.4436 61.3827 33.1015 58.5428C33.3017 57.5679 33.1773 56.5541 32.7475 55.6568C32.0275 54.1266 32.6135 55.5606 32.6135 55.5606L31.3436 52.833Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4578 52.8154L22.8821 54.2193L22.6441 57.7912C22.6441 57.7912 22.4441 59.4618 23.1341 60.0655C23.8241 60.6692 29.5579 61.3651 33.2158 58.5252C33.416 57.5503 33.2916 56.5365 32.8618 55.6392C32.1418 54.109 32.7278 55.543 32.7278 55.543L31.4578 52.8154Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3934 52.8252L22.8177 54.2291L22.5797 57.807C22.5797 57.807 22.3797 59.4776 23.0697 60.0813C23.7596 60.6849 29.4934 61.3809 33.1513 58.541C33.3515 57.5661 33.2271 56.5523 32.7973 55.655C32.0774 54.1248 32.6633 55.5588 32.6633 55.5588L31.3934 52.8252Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.9844 50.9468L28.4145 50.3828L28.9279 53.5237C29.0481 54.2593 28.5509 54.9534 27.8173 55.074L27.0418 55.2015C26.3082 55.3221 25.616 54.8235 25.4958 54.0879L24.9824 50.947L24.9844 50.9468Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.9639 50.8188L28.394 50.2549L28.9074 53.3958C29.0276 54.1314 28.5304 54.8255 27.7968 54.9461L27.0212 55.0736C26.2877 55.1941 25.5955 54.6956 25.4753 53.9599L24.9619 50.819L24.9639 50.8188Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.0475 51.3146C26.2207 51.5476 27.4382 51.3513 28.4794 50.7611L28.4094 50.3379L24.9795 50.9034L25.0475 51.3146Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.0053 51.3266C28.7567 51.3266 30.9871 49.0899 30.9871 46.3308C30.9871 43.5717 28.7567 41.335 26.0053 41.335C23.2539 41.335 21.0234 43.5717 21.0234 46.3308C21.0234 49.0899 23.2539 51.3266 26.0053 51.3266Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.0156 45.3588L30.3933 43.8186C30.3933 43.8186 28.9714 40.1524 25.4675 40.9787C21.9636 41.805 21.0156 45.3588 21.0156 45.3588Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.9941 45.2319L30.3798 43.6897C30.3798 43.6897 28.9579 40.0235 25.454 40.8498C21.9501 41.6761 20.9941 45.2319 20.9941 45.2319Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.352 48.0698C21.6057 48.0287 21.7491 47.6087 21.6723 47.1317C21.5954 46.6548 21.3274 46.3014 21.0737 46.3426C20.82 46.3837 20.6766 46.8037 20.7534 47.2806C20.8302 47.7576 21.0982 48.1109 21.352 48.0698Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8995 46.1914C31.1524 46.1499 31.2944 45.7307 31.2166 45.2553C31.1389 44.7798 30.8709 44.4281 30.618 44.4696C30.3651 44.5112 30.2232 44.9304 30.3009 45.4058C30.3787 45.8813 30.6467 46.233 30.8995 46.1914Z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.688 83.6787H56.459V142.959H135.688V83.6787Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.688 33.1807H56.459V83.6784H135.688V33.1807Z",
    fill: "#808080"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M134.68 33.9893H57.4668V141.34H134.68V33.9893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91.4738 70.5049H67.7773V70.5129H91.4738V70.5049Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91.4738 57.6348H67.7773V70.5044H91.4738V57.6348Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91.4738 46.6729H67.7773V57.636H91.4738V46.6729Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91.4738 46.6709H67.7773V46.6715H91.4738V46.6709Z",
    fill: "#808080"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M79.6234 70.0751C85.9701 70.0751 91.1151 64.9157 91.1151 58.5512C91.1151 52.1868 85.9701 47.0273 79.6234 47.0273C73.2768 47.0273 68.1318 52.1868 68.1318 58.5512C68.1318 64.9157 73.2768 70.0751 79.6234 70.0751Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1163 62.9414C75.1163 62.9414 72.3784 63.164 73.1023 68.1779C73.4779 68.5391 73.9211 68.8219 74.4063 69.0102L75.9463 63.7817L75.1163 62.9414Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0017 62.9414C84.0017 62.9414 86.7396 63.164 86.0156 68.1779C85.64 68.5391 85.1969 68.8219 84.7117 69.0102L83.1777 63.7657L84.0017 62.9414Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2337 54.7402C75.2337 54.7402 75.0237 55.3559 74.7237 56.0679C74.0717 57.6242 74.8157 63.6048 76.3756 64.2425C78.1256 64.9585 80.4275 65.4158 82.8174 64.5413C84.8953 63.7812 85.5353 56.9744 84.0674 55.3158C83.8954 55.1153 83.7154 54.9288 83.5274 54.7402H75.2337Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6319 59.4936C82.4452 59.4936 84.7258 57.2066 84.7258 54.3855C84.7258 51.5643 82.4452 49.2773 79.6319 49.2773C76.8187 49.2773 74.5381 51.5643 74.5381 54.3855C74.5381 57.2066 76.8187 59.4936 79.6319 59.4936Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M83.9493 62.9414H75.0636L74.2336 66.5053C74.2336 66.5053 73.7456 68.1558 74.3516 68.8818C74.9576 69.6078 80.6174 71.2584 84.7772 69.0002C85.1396 68.0497 85.181 67.0062 84.8952 66.0299C84.4213 64.3673 84.7772 65.9116 84.7772 65.9116L83.9493 62.9414Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M84.0675 62.9414H75.1778L74.3478 66.5053C74.3478 66.5053 73.8599 68.1558 74.4658 68.8818C75.0718 69.6078 80.7316 71.2584 84.8915 69.0002C85.2539 68.0497 85.2953 67.0062 85.0095 66.0299C84.5355 64.3673 84.8915 65.9116 84.8915 65.9116L84.0675 62.9414Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.002 62.9414H75.1163L74.2863 66.5053C74.2863 66.5053 73.7983 68.1558 74.4043 68.8818C75.0103 69.6078 80.6701 71.2584 84.83 69.0002C85.1924 68.0497 85.2338 67.0062 84.948 66.0299C84.474 64.3673 84.83 65.9116 84.83 65.9116L84.002 62.9414Z",
    fill: "#3AD29F"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M77.8418 59.9834H81.3957V63.2685C81.3957 64.0139 80.7931 64.6182 80.0498 64.6182H79.1858C78.4424 64.6182 77.8398 64.0139 77.8398 63.2685V59.9834H77.8418Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.8418 59.8506H81.3957V63.1357C81.3957 63.8811 80.7931 64.4854 80.0498 64.4854H79.1858C78.4424 64.4854 77.8398 63.8811 77.8398 63.1357V59.8506H77.8418Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M77.8477 60.3562C78.9942 60.7821 80.255 60.7821 81.4015 60.3562V59.9189H77.8477V60.3562Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.6319 60.603C82.4452 60.603 84.7258 58.316 84.7258 55.4948C84.7258 52.6737 82.4452 50.3867 79.6319 50.3867C76.8187 50.3867 74.5381 52.6737 74.5381 55.4948C74.5381 58.316 76.8187 60.603 79.6319 60.603Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7598 53.5552H84.4755C84.4755 53.5552 83.6455 49.6203 79.9736 49.873C76.3017 50.1257 74.7598 53.5552 74.7598 53.5552Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6439 56.1686C74.9057 56.1686 75.1179 55.7699 75.1179 55.2782C75.1179 54.7864 74.9057 54.3877 74.6439 54.3877C74.3821 54.3877 74.1699 54.7864 74.1699 55.2782C74.1699 55.7699 74.3821 56.1686 74.6439 56.1686Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5961 56.1686C84.8578 56.1686 85.07 55.7699 85.07 55.2782C85.07 54.7864 84.8578 54.3877 84.5961 54.3877C84.3343 54.3877 84.1221 54.7864 84.1221 55.2782C84.1221 55.7699 84.3343 56.1686 84.5961 56.1686Z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M74.7598 53.6851H84.4755C84.4755 53.6851 83.6455 49.7502 79.9736 50.0029C76.3017 50.2556 74.7598 53.6851 74.7598 53.6851Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.49 80.5381H67.7617V83.9255H123.49V80.5381Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.49 89.0049H67.7617V92.3923H123.49V89.0049Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.492 53.4434H94.7832V56.8307H123.492V53.4434Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.959 61.9102H97.3154V65.2975H120.959V61.9102Z",
    fill: "#F5D776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.736 97.4727H67.7617V100.86H116.736V97.4727Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.98 105.94H67.7617V109.328H109.98V105.94Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.915 114.409H67.7617V117.797H104.915V114.409Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.046 122.877H67.7617V126.264H115.046V122.877Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3371 131.345H67.7617V134.732H86.3371V131.345Z",
    fill: "#F5D776"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M147.222 131.722H113.467V150H147.222V131.722Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M147.222 116.15H113.467V131.721H147.222V116.15Z",
    fill: "#808080"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M130.344 149.004C139.117 149.004 146.228 141.872 146.228 133.076C146.228 124.279 139.117 117.147 130.344 117.147C121.572 117.147 114.461 124.279 114.461 133.076C114.461 141.872 121.572 149.004 130.344 149.004Z",
    fill: "#305569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.451 130.95L129.406 136.425L137.844 123.982L140.824 126.471L129.406 141.403L120.969 131.946L123.451 130.95Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3810_10118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.834,
    height: 150,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapers);
export default __webpack_public_path__ + "static/media/papers.3c6bf35014139091d3180444c1f4d260.svg";
export { ForwardRef as ReactComponent };